// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

const { jwt } = useJwt({
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken',
})

export default jwt
